export default {
	"item.NoInformationWasObtained": "No information was obtained",
	"item.AGoodThingToShareWithYou": "A good thing to share with you",
	"item.LimitedTimeDiscountedPrices": "Limited-time discounted prices",
	"item.ThePosterIsBeingGenerated": "The poster is being generated",
	"item.rise": "rise"
}